import { cn } from '../ui/utils';

interface TypographyProps {
  children: React.ReactNode;
  className?: string;
}

export function PageTitle({ children, className }: TypographyProps) {
  return <h1 className={cn('mb-4 text-xl font-semibold', className)}>{children}</h1>;
}

export function PageSubTitle({ children, className }: TypographyProps) {
  return <p className={cn('text-sm', className)}>{children}</p>;
}
